import { Component, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
	selector: 'group-item',
	templateUrl: 'group-item.html'
})
export class GroupItemComponent implements AfterViewInit {

	@Input('data') groupDetail: any = {};
	@Input('task') task = "";
	@Output('onSendMessage') onSendMessage: EventEmitter<any> = new EventEmitter();
	@Output('onSelectGroup') onSelectGroup: EventEmitter<any> = new EventEmitter();
	constructor() {
	}


	ngAfterViewInit() {
	}

	showGroupMembers() {
		if (!this.groupDetail.useroptions)
			this.groupDetail.useroptions = true;
		else
			this.groupDetail.useroptions = false
	}

	selectGroup(selected) {
		this.onSelectGroup.emit({
			group: this.groupDetail ,
			added: selected
		})
	}

}



// WEBPACK FOOTER //
// ./src/components/group-item/group-item.ts